<script>
  import { MenuItem } from 'element-ui'
  export default {
    name:'ElMenuItem',
    extends:MenuItem
  }
</script>
